import { render, staticRenderFns } from "./elearea1.vue?vue&type=template&id=48745d14&scoped=true&"
import script from "./elearea1.vue?vue&type=script&lang=js&"
export * from "./elearea1.vue?vue&type=script&lang=js&"
import style0 from "./elearea1.vue?vue&type=style&index=0&id=48745d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48745d14",
  null
  
)

export default component.exports